<template>
    <modal-component :visible="visible" id="cant-submit-claim-modal" @close="resetModal()">
        <div class="p-3">
            <span data-private="lipsum">
                {{ patient.name }}'s information needs to be completed in order to submit a claim.
            </span>
            <div class="w-100 d-flex justify-content-end">
                <a :href="`/patients/${patient.id}/details`" class="btn btn-sm btn-primary"
                    >Complete patient info</a
                >
            </div>
        </div>
    </modal-component>
</template>

<script>
import ModalComponent from "../ui/ModalComponent";
export default {
    name: "CantSubmitClaim",
    components: {
        ModalComponent,
    },
    data() {
        return {
            patient: {},
            visible: false,
        };
    },
    methods: {
        resetModal() {
            this.patient = {};
            this.visible = false;
        },
    },
};
</script>

<style scoped></style>
